import React, { ReactNode } from "react"
import { Accordion } from "@mantine/core"

import { useStyles } from "@/components/UnstyledAccordion/UnstyledAccordion.styles"

interface UnstyledAccordionProps {
    children: ReactNode
    title: string
}

export const UnstyledAccordion = ({ children, title }: UnstyledAccordionProps) => {
    const { classes } = useStyles()

    return (
        <Accordion variant="filled" className={classes.content}>
            <Accordion.Item value="default" className={classes.item}>
                <Accordion.Control className={classes.title}>{title}</Accordion.Control>
                <Accordion.Panel>{children}</Accordion.Panel>
            </Accordion.Item>
        </Accordion>
    )
}
